import React from "react";

export const AttachmentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1263 6.5V17.0417C16.1263 19.0675 14.4855 20.7083 12.4596 20.7083C10.4338 20.7083 8.79297 19.0675 8.79297 17.0417V5.58334C8.79297 4.31834 9.81964 3.29167 11.0846 3.29167C12.3496 3.29167 13.3763 4.31834 13.3763 5.58334V15.2083C13.3763 15.7125 12.9638 16.125 12.4596 16.125C11.9555 16.125 11.543 15.7125 11.543 15.2083V6.5H10.168V15.2083C10.168 16.4733 11.1946 17.5 12.4596 17.5C13.7246 17.5 14.7513 16.4733 14.7513 15.2083V5.58334C14.7513 3.55751 13.1105 1.91667 11.0846 1.91667C9.0588 1.91667 7.41797 3.55751 7.41797 5.58334V17.0417C7.41797 19.8283 9.67297 22.0833 12.4596 22.0833C15.2463 22.0833 17.5013 19.8283 17.5013 17.0417V6.5H16.1263Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
